import Items from './items'
type TFooterItemType = {
    title: string
    icon?: string
    router: string
    isMain?: boolean
    isActive?: boolean
    main: boolean
    role: string
    activeIcon: string
}

const FooterItem = ({
    title,
    icon,
    router,
    isMain,
    isActive = false,
    main,
    role,
    activeIcon,
}: TFooterItemType) => {
    return (
        <div className="flex flex-1 flex-col items-center pb-1.5 pt-1.5">
            <Items
                role={role}
                isActive={isActive}
                title={title}
                icon={icon}
                router={router}
                activeIcon={activeIcon}
            />
        </div>
    )
}

export default FooterItem
